import { InjectionToken } from '@angular/core';

export const FORMS_URL = new InjectionToken<string>('FORMS_URL');
